import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WalletTwoToneSvg from "@ant-design/icons-svg/es/asn/WalletTwoTone";
import AntdIcon from '../components/AntdIcon';
var WalletTwoTone = function WalletTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: WalletTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(WalletTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'WalletTwoTone';
}
export default RefIcon;